// @flow
// Inspired by https://github.com/petermoresi/react-download-link
import * as React from 'react'
import { Button } from 'semantic-ui-react'

type BaseComponentProps = {
  label: string,
  data: Array<Object>,
  sheetname: string,
  filename: string,
  style: Object,
}

class DownloadLink extends React.Component<BaseComponentProps> {
  static defaultProps = {
    label: 'Scarica',
    data: [],
    sheetname: 'Tracciato Record',
    filename: 'export.xlsx',
    style: {},
  }

  handleDownloadClick = (e: SyntheticEvent<*>) => {
    import('xlsx').then(XLSX => {
      // Create XLSX
      let wopts = { bookType: 'xlsx', bookSST: false, type: 'binary' }
      let ws = XLSX.utils.json_to_sheet(this.props.data)
      let workbook = { SheetNames: [this.props.sheetname], Sheets: {} }
      workbook.Sheets[this.props.sheetname] = ws
      let wbout = XLSX.write(workbook, wopts)
      function s2ab(s) {
        let buf = new ArrayBuffer(s.length)
        let view = new Uint8Array(buf)
        for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
        return buf
      }

      // Create ObjectURL from Blob
      let blob = new Blob([s2ab(wbout)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      let url = URL.createObjectURL(blob)

      if (window.navigator.msSaveOrOpenBlob) {
        //IE11 support
        window.navigator.msSaveOrOpenBlob(blob, this.props.filename)
      } else {
        // Add ghost A elem and trigger download
        let element = document.createElement('a')
        if (!document.body) throw new Error()
        document.body.appendChild(element)
        element.setAttribute('href', url)
        element.setAttribute('download', this.props.filename)
        element.style.display = ''
        element.click()

        // Cleanup
        if (!document.body) throw new Error()
        document.body.removeChild(element)
        URL.revokeObjectURL(url)
      }

      e.stopPropagation()
      return true
    })
  }

  render() {
    return (
      <a style={{ ...this.props.style, cursor: 'pointer' }} onClick={this.handleDownloadClick}>
        {this.props.label}
      </a>
    )
  }
}

type Props = {
  label: string,
  data: Array<Object>,
  sheetname: string,
  filename: string,
  style: Object,
  mode: 'link' | 'button',
}

class DownloadXLSX extends React.Component<Props> {
  static defaultProps = {
    label: 'Scarica',
    data: [],
    sheetname: 'Tracciato Record',
    filename: 'export.xlsx',
    style: {},
    mode: 'link',
  }

  downloadLink: ?DownloadLink

  render() {
    if (this.props.mode === 'link') {
      return <DownloadLink {...this.props} />
    } else {
      let props = { ...this.props }
      delete props.label
      return (
        <Button
          content={
            <DownloadLink
              ref={dl => {
                this.downloadLink = dl
              }}
              label={this.props.label}
              filename={this.props.filename}
              data={this.props.data}
              sheetname={this.props.sheetname}
              style={{ color: 'white' }}
            />
          }
          onClick={e => {
            if (this.downloadLink) {
              this.downloadLink.handleDownloadClick(e)
            }
          }}
          {...props}
        />
      )
    }
  }
}

export default DownloadXLSX



// WEBPACK FOOTER //
// ./src/systemwide/download-xlsx.js